import React from "react";
import { Popover, PopoverContent, PopoverTrigger } from "../shadcn/ui/popover";
import { Constants } from "../utils/constants";

const HDayPopover = ({ children, date, bookings = [], formatTimeRange, onViewAllEvents }) => {
  const formatDate = date => {
    return date.toLocaleDateString("en-US", {
      weekday: "long",
      month: "long",
      day: "numeric",
      year: "numeric",
    });
  };

  const handleViewAllEvents = () => {
    if (onViewAllEvents) {
      onViewAllEvents(date);
    }
  };

  return (
    <Popover>
      <PopoverTrigger asChild>{children}</PopoverTrigger>
      <PopoverContent className="w-80 p-0 shadow-lg border border-gray-200" align="center" sideOffset={8}>
        {/* Header */}
        <div
          className="px-4 py-3 text-white rounded-t-md"
          style={{ backgroundColor: Constants.HOST_EXPERIENCE_BASE_COLOR }}
        >
          <h3 className="font-semibold text-sm">{formatDate(date)}</h3>
        </div>

        {/* Content */}
        <div className="p-4">
          {bookings.length > 0 ? (
            <div className="space-y-3">
              <h4 className="text-sm font-medium text-gray-900 mb-3">
                {bookings.length} Event{bookings.length !== 1 ? "s" : ""}
              </h4>
              {bookings.map(booking => (
                <div
                  key={booking.id}
                  className="flex items-start space-x-3 p-3 rounded-lg border border-gray-100 hover:bg-gray-50 transition-colors"
                >
                  {/* Avatar */}
                  <div className="w-8 h-8 rounded-full overflow-hidden bg-gray-200 flex-shrink-0">
                    <img
                      src={booking.avatar}
                      alt={booking.name}
                      className="w-full h-full object-cover"
                      onError={e => {
                        e.target.style.display = "none";
                        e.target.parentNode.innerHTML = `<div class="w-full h-full bg-gray-300 flex items-center justify-center text-gray-600 text-xs font-medium">${booking.name
                          .split(" ")
                          .map(n => n[0])
                          .join("")}</div>`;
                      }}
                    />
                  </div>

                  {/* Event Details */}
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center justify-between">
                      <p className="text-sm font-medium text-gray-900 truncate">{booking.name}</p>
                      <div
                        className="w-3 h-3 rounded-full flex-shrink-0 ml-2"
                        style={{
                          backgroundColor: Constants.HOST_EXPERIENCE_BASE_COLOR,
                        }}
                      ></div>
                    </div>
                    <p className="text-xs text-gray-500 mt-1">{booking.email}</p>
                    <p className="text-xs font-medium text-gray-700 mt-1">
                      {formatTimeRange(booking.startTime, booking.endTime)}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="text-center py-6">
              <div className="w-12 h-12 mx-auto mb-3 rounded-full bg-gray-100 flex items-center justify-center">
                <svg className="w-6 h-6 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                  />
                </svg>
              </div>
              <p className="text-sm text-gray-500">No events scheduled</p>
              <p className="text-xs text-gray-400 mt-1">This day is available for booking</p>
            </div>
          )}
        </div>

        {/* Footer */}
        {bookings.length > 0 && (
          <div className="px-4 py-3 bg-gray-50 rounded-b-md border-t border-gray-100">
            <button
              onClick={handleViewAllEvents}
              className="text-xs font-medium hover:underline transition-colors"
              style={{ color: Constants.HOST_EXPERIENCE_BASE_COLOR }}
            >
              View all events
            </button>
          </div>
        )}
      </PopoverContent>
    </Popover>
  );
};

export default HDayPopover;
